import React from 'react'
import { Grid2,Paper,Typography } from '@mui/material'
import AllSpices from "../../../assets/Home/AboutusHero2.jpg"
import "../About.css"

export function AboutInfoDesktop() {
  return (
    <Grid2 container className="Transfercontainer" height="calc(100vh - 8rem)">
      <Grid2 container className="basecontainer">
        <Grid2  className="imagecontainer">
          <img component={Paper} width="100%" style={{borderRadius:"10px"}} src={AllSpices} alt="" />
        </Grid2>
        <Grid2 className="textcontainer">
          <Typography className="infoheading">WELCOME TO GBG EXPORTS</Typography>
          <Typography className="infotext">
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Vel, officiis eaque. Voluptate quibusdam, ducimus neque Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestiae, doloremque. Veniam provident id at aspernatur eius vel totam dolores saepe nobis nisi quia, libero labore! Facere quam non illum ducimus. magni, provident sed voluptate! Lorem ipsum dolor sit amet consectetur adipisicing elit. Beatae pariatur quidem, voluptas quaerat earum explicabo asperiores doloremque? Consequuntur molestiae necessitatibus perspiciatis itaque, consequatur quibusdam sed saepe ullam molestias, optio omnis!
          </Typography>
        </Grid2>
      </Grid2>
    </Grid2>
  )
}

 